import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'

import { onFiltrosParaEmbarqueChange } from '../actions/filtroCerealCerealVariedadYEtiquetaActions'
import { renderSelectFieldWithOptions } from '../../../../Forms/fieldRenderers'
import { FORM_FILTRO_CEREAL_CEREAL_VARIEDAD_Y_ETIQUETA } from '../../../../../config/forms'
import { CerealVariedadDropdown } from '../../../../Forms/SharedComponents/containers'
import { required } from '../../../../Forms/fieldValidators'

export let FiltroCerealCerealVariedadYEtiquetaForm = props => {
  const { handleSubmit, invalid, submitting } = props
  return (
    <form onSubmit={handleSubmit}>
      <Container fluid>
        <Row style={{ textAlign: 'left' }}>
          <Col md={3} />
          <Col md={6}>
            <CerealVariedadDropdown />
          </Col>
          <Col md={3} />
        </Row>
        <Row style={{ textAlign: 'left' }}>
          <Col md={3} />
          <Col md={6}>
            <Field
              validate={[required]}
              name='etiqueta'
              label='Etiqueta'
              placeholder='Etiqueta'
              options={props.etiquetas}
              component={renderSelectFieldWithOptions}
              type='text'
            />
          </Col>
          <Col md={3} />
        </Row>
        <Row>
          <Col md={3} />
          <Col md={6} className='d-flex justify-content-center' >
            <Button
              variant='primary'
              type='submit'
              size='lg'
              disabled={invalid || submitting}
            >Filtrar</Button>
          </Col>
          <Col md={3} />
        </Row>
      </Container>
    </form>
  )
}
FiltroCerealCerealVariedadYEtiquetaForm = reduxForm({
  form: FORM_FILTRO_CEREAL_CEREAL_VARIEDAD_Y_ETIQUETA,
  onChange: onFiltrosParaEmbarqueChange
})(FiltroCerealCerealVariedadYEtiquetaForm)
